import { render, staticRenderFns } from "./GeoComponent.vue?vue&type=template&id=516083cc&scoped=true&"
import script from "./GeoComponent.vue?vue&type=script&lang=ts&"
export * from "./GeoComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516083cc",
  null
  
)

export default component.exports